import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

// https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_browser.html

export default {
    computed: {
        ...mapGetters({
            config: 'azureAuth/Config',
            scopes: 'azureAuth/Scopes',
            instance: 'azureAuth/Instance',
            accounts: 'azureAuth/Accounts',
            account: 'azureAuth/Account',
        }),
        UPNDomain() { return '@dundeeandangus.ac.uk'; },
        Accounts() { return this.accounts || []; },
        Account() { return this.account || {}; },
        AuthorisationHeader() { return { headers: { Authorization: `Bearer ${sessionStorage.accessToken}`, 'Content-Type': 'application/json' } }; },
    },
    methods: {
        ...mapActions({
            SetAuthority: 'azureAuth/SetAuthority',
            SetClientID: 'azureAuth/SetClientID',
            SetInstance: 'azureAuth/SetInstance',
            SetAccounts: 'azureAuth/SetAccounts',
            SetAccount: 'azureAuth/SetAccount',
            SetAccessToken: 'azureAuth/SetAccessToken',
            ClearAuth: 'azureAuth/ClearAuth',
        }),
        SignIn() {
            eventBus.$emit('sign-in:started');
            this.instance.handleRedirectPromise()
                .then(() => {
                    const accounts = this.instance.getAllAccounts();

                    this.SetAccounts(accounts);

                    if (!!accounts) {
                        switch (accounts.length) {
                            case 0:
                                this.instance.loginRedirect();
                                break;
                            case 1:
                                this.SetAccount(accounts[0]);
                                eventBus.$emit('sign-in:success', accounts[0]);
                                break;
                            default:
                                this.instance.logout({});
                                break;
                        }
                    }
                    else this.instance.loginRedirect();
                }).catch(error => eventBus.$emit('console:error', error));
        },
        ForceSignIn() {
            this.instance.loginRedirect({
                scopes: this.scopes,
                prompt: 'select_account',
            });
        },
        SignOut() {
            let loginMethod = sessionStorage.loginMethod;
            sessionStorage.clear();
            sessionStorage.loginMethod = loginMethod;

            this.ClearAuth();

            this.instance.logout({}).catch(error => eventBus.$emit('console:error', error));
        },
        GetAccessToken(account) {
            eventBus.$emit('access-token-fetch:started');
            if (!account) eventBus.$emit('access-token-fetch:failed');
            else {
                this.instance.acquireTokenSilent({ scopes: this.scopes, account: this.account })
                    .then(response => {
                        sessionStorage.accessToken = response.accessToken;
                        eventBus.$emit('access-token-fetch:success');
                    })
                    .catch(() => {
                        this.instance.acquireTokenRedirect({ scopes: this.scopes, account: this.account })
                            .then(response => {
                                sessionStorage.accessToken = response.accessToken;
                                eventBus.$emit('access-token-fetch:success');
                            })
                            .catch(error => {
                                eventBus.$emit('console:error', error);
                                eventBus.$emit('access-token-fetch:failed');
                            });
                    });
            }
        },
        ReacquireAccessToken() {
            if (sessionStorage.accessToken != null) {
                let tokens = sessionStorage.accessToken?.split('.');

                if (tokens.length > 1) {
                    let segment2 = JSON.parse(atob(tokens[1]));
                    let expiryDate = new Date(segment2.exp * 1000);

                    if (expiryDate != null) {
                        let difference = expiryDate - new Date();

                        if (difference <= 0) {
                            clearInterval(this.accessTokenIntervalID);
                            sessionStorage.removeItem('accessToken');
                            this.GetAccessToken();
                        }
                    }
                }
            }
        }
    }
};